import { useMemo } from 'react';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { usePropertyDefinitionsByObjectTypeId } from '../../v2/hooks/usePropertyDefinition';
import { CdpInfotip } from '../../v2/ui/CdpInfotip';
import { Stack } from 'trellis-components/components/layout/Stack';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const InvalidChangesTooltip = ({
  invalidRequests,
  children
}) => {
  const invalidRequestIds = useMemo(() => invalidRequests.map(request => request.objectTypeId), [invalidRequests]);
  const {
    data: definitions
  } = usePropertyDefinitionsByObjectTypeId(invalidRequestIds);
  const changes = useMemo(() => {
    return invalidRequests.flatMap(request => request.updates.properties.map(({
      name
    }) => {
      var _definitions$request$;
      return {
        key: `${request.objectTypeId}-${request.objectId}-${name}`,
        label: definitions === null || definitions === void 0 || (_definitions$request$ = definitions[request.objectTypeId]) === null || _definitions$request$ === void 0 || (_definitions$request$ = _definitions$request$[name]) === null || _definitions$request$ === void 0 ? void 0 : _definitions$request$.property.label
      };
    }));
  }, [invalidRequests, definitions]);
  return /*#__PURE__*/_jsx(CdpInfotip, {
    disabled: changes.length === 0,
    use: "longform",
    headingText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.autosave.invalidChangesTooltipHeading"
    }),
    title: /*#__PURE__*/_jsxs(Stack, {
      space: "xs",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.autosave.unsavedChangesTooltipBody",
        options: {
          count: changes.length
        }
      }), /*#__PURE__*/_jsx(List, {
        styled: true,
        paddingInlineStart: "400",
        children: changes.map(change => /*#__PURE__*/_jsx(ListItem, {
          children: change.label
        }, change.key))
      })]
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: children(changes.length)
    })
  });
};
export default InvalidChangesTooltip;